import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import background_img from "../img/Home_back.png";
import Big_data from "../img/Big_data.png";
import Bio_informatics from "../img/Bio-informatics_andclinical.png";
import Comparative from "../img/Comparative_effectiveness.png";
import Intelligence from "../img/intelligence.png";
import Prospective from "../img/Prospective.png";
import Translational from "../img/Translational_research.png";
import Crow_1 from "../img/Crow/4.png";
import Crow_2 from "../img/Crow/5.png";

function Home_item_1 (){
    return (
      <Category_wrapper>
          <Item_wrapper>
          <Span_div>
            <Content_span>
                HOME
            </Content_span>
            <Content_span2>
            Our goal is to go beyond the limits of traditional clinical science through innovative data science using high quality data in urology. Our area of expertise are prospective cohort and clinical trial, artificial intelligence including machine intelligence and deep learning, big data analysis using public clinical data, bio-informatics and next generation sequencing, translational research, quality of life research, and comparative effectiveness research. Sometimes, our researches are not limited in the field of Urology and strives to develop better clinical research platform or perform innovative research on healthcare informatics using clinical data warehouse (CDW) and common data model (CDM).
We always welcome any kind of research collaboration using our high quality clinical data, bio-specimen, research resources and methodology.
            </Content_span2>
          </Span_div>
        <Category_list_ul>
          <Category_list_li>
            <Item_img color={Prospective}/>
            <Item_content_wrapper>
                <Item_span_title>
                Prospective cohort/Clinical trial
                </Item_span_title>
                <Item_content>
                We initiated and have performed various prospective cohort studies and clinical trial to provide the highest quality of clinical data and bio-specimen. We are also a coordinating center for many multicenter, prospective cohort or retrospective database.
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
          <Category_list_li>
          <Item_img color={Intelligence}/>
          <Item_content_wrapper>
                <Item_span_title>
                Artificial intelligence
                </Item_span_title>
                <Item_content>
                We are generating various data for AI research prospective cohort or high quality retrospective clinical data. We are applying various AI algorithm to many clinical big data, medical image and surgical video.
                </Item_content>
            </Item_content_wrapper>
            </Category_list_li>
            <Category_list_li>
          <Item_img color={Big_data}/>
          <Item_content_wrapper>
                <Item_span_title>
                Big data analysis 
                </Item_span_title>
                <Item_content>
                We perform impactful research using various publically opened dataset or representative cohort data such as the Korean National Health Insurance Service Data, the Cancer of the Prostate Strategic Urologic Research Endeavor Registry (CaPSURE), and Surveillance, Epidemiology, and End Results (SEER) data.   
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
          </Category_list_ul>
          <Category_list_ul>
          <Category_list_li>
          <Item_img color={Bio_informatics}/>
          <Item_content_wrapper>
                <Item_span_title>
                Bio-informatics and clinical genetics 
                </Item_span_title>
                <Item_content>
                We are generating various NGS data such as GWAS, WGS, WES, RNAseq, proteomics and cancer panel in prospective cohort. We also perform comprehensive, highly focused genetic researches on specific disease condition.
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
          <Category_list_li>
          <Item_img color={Translational}/>
          <Item_content_wrapper>
                <Item_span_title>
                Translational research and bio-marker study 
                </Item_span_title>
                <Item_content>
                We perform various type of translational researches to develop diagnostic or prognostic biomarkers using bio-specimen linked to our prospective cohort.
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
          <Category_list_li>
          <Item_img color={Comparative}/>
          <Item_content_wrapper>
                <Item_span_title>
                Comparative effectiveness research (CEA) 
                </Item_span_title>
                <Item_content>
                Comparative effectiveness research including Health-related quality of life study, clinical decision analysis, and cost-effectiveness analysis is one of the major field of our research. 
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
        </Category_list_ul>
        </Item_wrapper>
        <Crow_img_1 src={Crow_1}/>
        <Crow_img_2 src={Crow_2}/>

      </Category_wrapper>
    )
  }
  const Crow_img_1 = styled.img`
  width : 150px; 
  height : 150px;
  position : absolute;
  top:1010px;
  right : 100px;
  `
  const Crow_img_2 = styled.img`
  width : 300px; 
  height : 177.867px;
  position : absolute;
  top:-90px;
  left : 0px;
  transform: rotateZ(30deg);
  `
  const Item_wrapper = styled.div`
    width : 1060px;
    margin : 70px auto;
  `
  const Item_content_wrapper = styled.div`
    padding : 5px 10px;
    text-align : left;
  `
  const Item_span_title = styled.div`
  font-family: "main_six_box_title";        
    font-weight : bold;
    font-size : 25px;
    padding : 10px 5px ;
    color : black;

  `
  const Item_content = styled.div`
  font-family: "main_six_box_content";        
    font-size : 20px;
    padding : 0 5px ;
    color : #212121;
    line-height : 25px;
  `
  const Item_img = styled.div`
    width : 280px;
    height :150px;
    background-image:url(${props => props.color}); 

  `
  const Category_wrapper = styled.div`
    width : 1200px;
    margin : 0px auto;
    padding : 50px 0;
    font-family: "En";    
    position : relative;    
    `
  const Category_list_ul=styled.ul`
    padding : 0 ;
    &:nth-child(3){
      margin-left : 130px;
    }
  `
  const Category_list_li = styled.li`
    position : relative;
    display : inline-block;
    margin-right : 20px;
    margin-bottom : 60px;
    width : 280px;
    height :570px;
    text-align : center;
    vertical-align : top;
    box-shadow: 5px 3px 5px rgba(70, 70, 70, 0.2);
    background: white;
    `
  const Content_span = styled.span`
    display : block;
    font-size : 35px; 
    font-weight : bold; 
    width : 350px;
    box-sizing : border-box  ;
    font-family: "Title";        

  `
  const Content_span2 = styled.span`
  font-family: "Content";        
  display : inline-block;
  font-size : 20px; 
  margin: 40px 0; 
  height : 30px;
  line-height : 35px;
  `
  const Span_div = styled.div`
    width : 1020px;
    text-align : left; 
    margin : 70px 0 ;
  `
  
  export default Home_item_1;